import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import {
  cancelarAltaClient,
  peticioAltaClient,
  tornarDespresAltaClient,
} from "../../utils/AltaClientRetorn";
import Seleccionarclient from "./Seleccionarclient";
import Contactes from "./Contactes";
import Clientrelacions from "./Clientrelacions";
import Detallsclient from "./Detallsclient";
import "../dashboard_v2.css";
import AjudaEntitats from "./AjudaEntitats";
import { BotoAjuda } from "./AjudaModal";

function idClient(c) {
  return c ? Number(c.idClients) : null;
}

function PestanyesClient({ active, onChange }) {
  return (
    <nav className="dv2-subnav" aria-label="Seccions del client">
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "dades" ? "is-active" : ""}`}
        onClick={() => onChange("dades")}
      >
        Dades
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "contactes" ? "is-active" : ""}`}
        onClick={() => onChange("contactes")}
      >
        Contactes
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "treballs" ? "is-active" : ""}`}
        onClick={() => onChange("treballs")}
      >
        Treballs
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "pressupostos" ? "is-active" : ""}`}
        onClick={() => onChange("pressupostos")}
      >
        Pressupostos
      </button>
    </nav>
  );
}

function Clients() {
  const location = useLocation();
  const navigate = useNavigate();
  const altaClient = peticioAltaClient(location);

  const [activeTab, setActiveTab] = useState(() => (altaClient ? "nou" : "seleccionar"));
  const [selectedClient, setSelectedClient] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [clientsList, setClientsList] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const { rolUsuari } = useUserContext();

  const tornarLlista = (refresca = false) => {
    if (cancelarAltaClient(navigate, altaClient)) return;
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleClientSelect = (client) => {
    if (!client) {
      setSelectedClient(null);
      return;
    }
    setSelectedClient((prev) => (idClient(prev) === idClient(client) ? null : client));
  };

  const obrirFitxa = (client, mode) => {
    setSelectedClient(client);
    setActiveTab(mode);
  };

  const anarTreballs = (client) => {
    if (!client?.idClients) return;
    navigate("/dashboard/treballs", { state: { client: client.idClients } });
  };

  const anarPressupostos = (client) => {
    if (!client?.idClients) return;
    navigate("/dashboard/pressupostos", { state: { client: client.idClients } });
  };

  const canviarSeccio = (seccio) => {
    if (seccio === "dades") {
      setActiveTab("consultar");
      return;
    }
    setActiveTab(seccio);
  };

  const esLlista = activeTab === "seleccionar";
  const mostraPestanyes = selectedClient && !["nou", "esborrar"].includes(activeTab);
  const seccioActiva =
    activeTab === "contactes" || activeTab === "treballs" || activeTab === "pressupostos"
      ? activeTab
      : "dades";
  const subnav = mostraPestanyes ? (
    <PestanyesClient active={seccioActiva} onChange={canviarSeccio} />
  ) : null;

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaEntitats pestanya="clients" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                👥
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Clients</h1>
                <p className="dv2-pageHeader-subtitle">
                  Fitxa del client, contactes, i accés a treballs i pressupostos.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Clients" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedClient(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou client
                </button>
              )}
            </div>
          </div>

          <Seleccionarclient
            onClientSelect={handleClientSelect}
            onConsultar={(c) => obrirFitxa(c, "consultar")}
            onModificar={(c) => obrirFitxa(c, "modificar")}
            onEsborrar={(c) => obrirFitxa(c, "esborrar")}
            onContactes={(c) => obrirFitxa(c, "contactes")}
            onTreballs={anarTreballs}
            onPressupostos={anarPressupostos}
            selectedClient={selectedClient}
            filterText={filterText}
            setFilterText={setFilterText}
            setClients={setClientsList}
            reloadToken={reloadToken}
          />
        </>
      ) : activeTab === "contactes" ? (
        <Contactes
          tipusPare="Client"
          entitat={selectedClient}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
        />
      ) : activeTab === "treballs" || activeTab === "pressupostos" ? (
        <Clientrelacions
          tipus={activeTab}
          client={selectedClient}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
          onObrir={
            activeTab === "treballs"
              ? () => anarTreballs(selectedClient)
              : () => anarPressupostos(selectedClient)
          }
        />
      ) : (
        <Detallsclient
          mode={activeTab}
          client={activeTab === "nou" ? null : selectedClient}
          clients={clientsList}
          subnav={subnav}
          onNavigate={setSelectedClient}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onTreballs={() => anarTreballs(selectedClient)}
          onPressupostos={() => anarPressupostos(selectedClient)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              if (tornarDespresAltaClient(navigate, altaClient, updated?.idClients)) return;
              tornarLlista(true);
              return;
            }
            setSelectedClient(updated);
            setClientsList((prev) =>
              (prev || []).map((c) => (idClient(c) === idClient(updated) ? { ...c, ...updated } : c))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Clients;
